<template>
  <div>
    <CookieWarn />
    <Home />
    <History />
    <Education />
    <Collaborations />
    <Location />
    <Highlights />
    <Contact />
    <Footer />
  </div>
</template>

<script>
import Home from '@/components/Home'
import Education from "@/components/Education"
import Collaborations from "@/components/Collaborations"
import Contact from "@/components/Contact"
import History from "@/components/History"
import Location from "@/components/parts/Location"
import Footer from "@/components/parts/Footer"
import Highlights from "@/components/Highlights"
import CookieWarn from "@/components/parts/CookieWarn"

export default {
  name: 'App',
  metaInfo: {
    title: 'Golden Race Foundation'
  },
  components: {
    Home,
    History,
    Education,
    Collaborations,
    Location,
    Contact,
    Footer,
    Highlights,
    CookieWarn
  }
}
</script>

<style>
@import "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,300;0,400;0,500;1,700&display=swap";
@import "https://fonts.googleapis.com/css2?family=Caveat+Brush&display=swap";

:root {
  font-family: 'Roboto', 'Caveat Brush';
}

.texto-roboto {
  font-family: 'Roboto';
}

.texto-caveat {
  font-family: 'Caveat Brush';
}

.color-gray {
  color: #40454B;
}

.text-home {
  color: #EFFFEC;
  line-height: 110%;
}

.line100 {
  line-height: 100%;
}

.line120 {
  line-height: 120%;
}

.line125 {
  line-height: 125%;
}

.line160 {
  line-height: 160% !important;
}

.line170 {
  line-height: 170%;
}

.text-card {
    line-height: 140%;
}

.col {
  border: 1px;
}

.card-group {
  color: #818A93;
}

.font-bold {
  font-weight: 700;
}

.font-medium {
  font-weight: 500;
}

.font-regular {
  font-weight: 400;
}

.font-thin {
  font-weight: 300;
}

.p {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 170%;
  letter-spacing: 0.4px;
}

@media screen and (min-width: 767px) {
  .p {
    font-size: 16px;
  }
}

.footer-txt {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 36px;
  line-height: 170%;
  text-align: center;
}

@media screen and (max-width: 767px) {
  .footer-txt {
    font-size: 26px;
  }
}

.background {
  background-image: url('../assets/images/background-mobile.png');
  background-size: 100% 100%;
}

@media screen and (min-width: 768px) {
  .background {
    background-image: url('../assets/images/background.png');
  }
}

.ts {
  font-size: 2.625rem;
}

@media screen and (min-width: 767px) {
  .ts {
    font-size: 4rem;
  }
}

</style>
